import { Constants } from '../../common/Constants';
import { setGeoLocationToStorage } from '../../common/PSXHeader/SearchBar/utils';
import { buildPortalData, setGuestPlanSelectionData } from './Guest.utils';

const JARVIS_PCP_PARAMS =
  'chipValue=Primary%20Care&coverageType=M&locale=en-US&landedOnDetailsPageFromSearch=false&search=Primary%20Care&searchType=speciality&providerType=&choosePCP=true&pcpIndicator=true';
export const saveLocationToStorage = (locationFeature: any) => {
  const {
    id: locationId,
    place_name: placeName,
    center = [],
    stateCode,
    zipCode,
  } = locationFeature;
  const [longitude, latitude] = center;

  setGeoLocationToStorage({
    id: locationId,
    name: placeName,
    longitude,
    latitude,
    stateCode,
    zipCode,
  });

  sessionStorage.setItem(
    Constants.STORAGE_KEYS.SESSION.GUEST_LOCATION,
    JSON.stringify({
      label: placeName,
      stateCode,
      zipcode: '',
    })
  );
};

export const savePlanDefinitionsToStorage = (planDefinitionsData: any) => {
  if (planDefinitionsData) {
    sessionStorage.setItem(
      Constants.STORAGE_KEYS.SESSION.AVAILABLE_PLANS,
      JSON.stringify(planDefinitionsData)
    );
  }
};

export const savePortalStateToStorage = (
  selectedPlan: any,
  stateCode: string,
  lob: string = 'MR'
) => {
  setGuestPlanSelectionData({
    selectedPlan,
    lob,
    coverageType: 'M',
    stateCode,
  });

  sessionStorage.setItem(
    Constants.STORAGE_KEYS.SESSION.PORTAL_STATE,
    JSON.stringify(
      buildPortalData(
        selectedPlan,
        lob,
        'M',
        stateCode,
        selectedPlan?.years?.[0]?.planYear
      )
    )
  );
};

export const findAcquisitionByClientCode = (
  acquisitionData: any[],
  clientCode: string
) =>
  acquisitionData?.find((item: any) =>
    item?.clientCode
      ?.split(',')
      .map((code: string) => code.trim())
      .includes(clientCode)
  );

export const getRedirectUrl = (
  acquisitionData: any,
  clientCode: string
): string | undefined =>
  findAcquisitionByClientCode(acquisitionData, clientCode)?.redirectUrl;

export const getPortalSource = (
  acquisitionData: any,
  clientCode: string
): string =>
  findAcquisitionByClientCode(acquisitionData, clientCode)?.portalSource ??
  'psx';

export const buildJarvisTargetUrl = (
  acquisitionData: any,
  clientCode: string
): string => {
  const redirectUrl = getRedirectUrl(acquisitionData, clientCode);
  return `${redirectUrl}?${JARVIS_PCP_PARAMS}`;
};

export const getSelectedPlan = (
  planDefinitionsData: any,
  clientProdCode: string
) =>
  planDefinitionsData?.planDetails?.find((plan: any) =>
    plan?.years?.some((year: any) => year?.reciprocityId === clientProdCode)
  ) ?? planDefinitionsData?.planDetails?.[0];
